<template>
    <section class="py-md-5 pb-5 pt-0 min-vh-100 d-flex align-items-center position-relative" id="tarot">
        <div class="container-xl position-relative pt-md-5 pt-0">
            <transition
            @before-enter="beforeEnter"
            @before-leave="beforeLeave"
            @enter="enter"
            @leave="leave"
            :css="false">
                <div class="row row-card-tarot position-relative main" ref="card" v-if="showCard && parent.data">
                    <div class="col-md-4 col-sm-6 mx-auto card-flip" v-for="(item, key) in parent.data.tarot" :key="key">
                        <div class="flip-card" ref="flipCard">
                            <div class="flip-card-inner" @click="clickCard(item)" :data-id="key"
                            :class="'pulse-card-' + key">
                                <div class="front">
                                    <img :src="parent.data.rewers" class="mh-100">
                                </div>
                                <div class="back">
                                    <img :src="item.url" class="mh-100">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                parent: this.$parent._data,
                activeCard: null,
                showCard: false,
                showDescrpition: false,
            }
        },
        mounted() {
            let _this = this;
            this.showCard = true;

            this.flipCard();
        },
        updated() {
            if(this.showCard)
            {
                this.flipCard();
            }
        },
        methods: {
            beforeEnter: function (el) {
                el.style.opacity = 0,
                el.style.top = '-100px'
            },
            beforeLeave: function(el) {
                el.style.opacity = 1,
                el.style.top = 0
            },
            enter: function (el, done) {
                $(el).animate({
                    opacity: 1,
                    top: 0,
                },1000, function(){
                    done();
                })
            },
            leave: function (el, done) {
                let _this = this;

                $(el).animate({
                    opacity: 0,
                    top: '-100px',
                },1000, function(el){
                    _this.$router.push({ name: "details", params: {type: 'tarot', id: _this.activeCard.id} })
                })
            },
            clickCard(item){
                this.activeCard = item;
                $(this.$refs.flipCard).css({pointerEvents: "none"});
            },
            flipCard(test){
                let _this = this;
                $('.flip-card-inner').each(function(){
                    if($(this).data('id') == 0) $(this).find('img').addClass('first');
                    else if($(this).data('id') == 1) $(this).find('img').addClass('second');
                    else if($(this).data('id') == 2) $(this).find('img').addClass('third');
                })

                $('.flip-card-inner').flip({
                    speed: 1000
                });

                $(".flip-card-inner").on('flip:done',function(){
                    $(this).parent().toggleClass('active');
                    setTimeout(function(){
                        _this.showCard = false;
                    }, 500)
                });
            },
        },
    }
</script>
